export class Tenant {

    idTenant:number;
    nome: string;
    stringConexao: string;
    multiTenant: boolean;
    idProjeto:number;
    objetoConfigComandoJson:string;
    parametroDistintorTenantWhere:string;
    comandoRecuperarDadosConexao:string;
}
